export default __webpack_public_path__ + "static/media/1374.5aef4bc3.png";